import awsImage from 'assets/img/agent-cloud/aws.svg';
import azureImage from 'assets/img/agent-cloud/azure.svg';
import esxiImage from 'assets/img/agent-cloud/esxi.svg';
import gcpImage from 'assets/img/agent-cloud/gcp.svg';
import kubernetesImage from 'assets/img/agent-cloud/kubernetes.svg';
import { CLOUD_PROVIDER, CloudProviderConfiguration, CloudProviderConfigurations } from './types';
export const notAvailable: string = 'N/A';

const AWS_CLOUD_PROVIDER_CONFIGURATION: CloudProviderConfiguration = {
  image: awsImage,
  title: 'Amazon Web Services',
  isSupported: true,
  fields: [
    {
      title: 'Account ID',
      key: 'cloudAccount',
      defaultValue: notAvailable,
    },
    {
      title: 'Location',
      key: 'cloudLocation',
      defaultValue: notAvailable,
    },
    {
      title: 'Network',
      key: 'cloudNetwork',
      defaultValue: notAvailable,
    },
    {
      title: 'Subnet IDs',
      key: 'awsSubnetIds',
      defaultValue: notAvailable,
    },
    {
      title: 'Instance ID',
      key: 'cloudInstanceId',
      defaultValue: notAvailable,
    },
    {
      title: 'Role',
      key: 'awsRole',
      defaultValue: notAvailable,
    },
    {
      title: 'Security Groups',
      key: 'awsSecurityGroups',
      defaultValue: notAvailable,
    },
    {
      title: 'Tags',
      key: 'cloudTags',
      defaultValue: notAvailable,
    },
    {
      title: 'Image',
      key: 'cloudImage',
      defaultValue: notAvailable,
    },
    {
      title: 'Instance Size',
      key: 'cloudInstanceSize',
      defaultValue: notAvailable,
    },
  ],
};

const AZURE_CLOUD_PROVIDER_CONFIGURATION: CloudProviderConfiguration = {
  image: azureImage,
  title: 'Microsoft Azure',
  isSupported: true,
  fields: [
    {
      title: 'Account ID',
      key: 'cloudAccount',
      defaultValue: notAvailable,
    },
    {
      title: 'Location',
      key: 'cloudLocation',
      defaultValue: notAvailable,
    },
    {
      title: 'Resource Group',
      key: 'azureResourceGroup',
      defaultValue: notAvailable,
    },
    {
      title: 'Instance ID',
      key: 'cloudInstanceId',
      defaultValue: notAvailable,
    },
    {
      title: 'Image',
      key: 'cloudImage',
      defaultValue: notAvailable,
    },
    {
      title: 'Tags',
      key: 'cloudTags',
      defaultValue: notAvailable,
    },
    {
      title: 'Instance Size',
      key: 'cloudInstanceSize',
      defaultValue: notAvailable,
    },
  ],
};

const GCP_CLOUD_PROVIDER_CONFIGURATION: CloudProviderConfiguration = {
  image: gcpImage,
  title: 'Google Cloud Platform',
  isSupported: true,
  fields: [
    {
      title: 'Account ID',
      key: 'cloudAccount',
      defaultValue: notAvailable,
    },
    {
      title: 'Location',
      key: 'cloudLocation',
      defaultValue: notAvailable,
    },
    {
      title: 'Instance ID',
      key: 'cloudInstanceId',
      defaultValue: notAvailable,
    },
    {
      title: 'Service Account',
      key: 'gcpServiceAccount',
      defaultValue: notAvailable,
    },
    {
      title: 'Tags',
      key: 'cloudTags',
      defaultValue: notAvailable,
    },
    {
      title: 'Network',
      key: 'cloudNetwork',
      defaultValue: notAvailable,
    },
    {
      title: 'Image',
      key: 'cloudImage',
      defaultValue: notAvailable,
    },
    {
      title: 'Instance Size',
      key: 'cloudInstanceSize',
      defaultValue: notAvailable,
    },
  ],
};

const KUBERNETES_CLOUD_PROVIDER_CONFIGURATION: CloudProviderConfiguration = {
  image: kubernetesImage,
  title: 'Kubernetes',
  isSupported: true,
  fields: [
    {
      title: 'Type',
      key: 'kubernetesType',
      defaultValue: notAvailable,
    },
    {
      title: 'Version',
      key: 'kubernetesVersion',
      defaultValue: notAvailable,
    },
    {
      title: 'Cluster name',
      key: 'clusterName',
      defaultValue: notAvailable,
    },
    {
      title: 'Node Name',
      key: 'kubernetesNodeName',
      defaultValue: notAvailable,
    },
    {
      title: 'Node Labels',
      key: 'kubernetesNodeLabels',
      defaultValue: notAvailable,
    },
    {
      title: 'Agent Namespace',
      key: 'agentNamespace',
      defaultValue: notAvailable,
    },
    {
      title: 'Agent Pod Name',
      key: 'agentPodName',
      defaultValue: notAvailable,
    },
  ],
};

const ESXI_PROVIDER_CONFIGURATION: CloudProviderConfiguration = {
  image: esxiImage,
  title: 'VMware ESXi',
  isSupported: false,
  fields: [],
};

export const CloudProvidersConfigurations: CloudProviderConfigurations = {
  [CLOUD_PROVIDER.AWS]: AWS_CLOUD_PROVIDER_CONFIGURATION,
  [CLOUD_PROVIDER.AZURE]: AZURE_CLOUD_PROVIDER_CONFIGURATION,
  [CLOUD_PROVIDER.GCP]: GCP_CLOUD_PROVIDER_CONFIGURATION,
  [CLOUD_PROVIDER.KUBERNETES]: KUBERNETES_CLOUD_PROVIDER_CONFIGURATION,
  [CLOUD_PROVIDER.ESXI]: ESXI_PROVIDER_CONFIGURATION,
};

export const MAX_CLOSE_MULTIPLE_FIELDS_VALUES = 2;
